import { SwitchSelect } from '@/global/components/SwitchSelect'
import React from 'react'
import localeText from '../../../../locales/datagrid'
import {
    GridFilterItemPro,
    GridFilterModelPro,
    LinkOperator,
} from '../utils/filterModelPro'

export default function FieldLinkOperator({
    item,
    onFilterModelChange,
}: {
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
}) {
    return (
        <SwitchSelect
            label="Lógica"
            variant="outlined"
            options={[
                {
                    value: LinkOperator.And,
                    label: localeText.filterPanelOperatorAnd,
                },
                {
                    value: LinkOperator.Or,
                    label: localeText.filterPanelOperatorOr,
                },
            ]}
            value={item.linkOperator || LinkOperator.And}
            onChange={valor => {
                onFilterModelChange(prev => ({
                    ...prev,
                    items: prev.items.map(p =>
                        p.id === item.id ? { ...p, linkOperator: valor } : p,
                    ),
                }))
            }}
        />
    )
}
